import { useLang } from "../../context/LanguageContext";
import {
  WifiHigh, Fire, Television, ForkKnife, Bathtub,
  CookingPot, Car, Key, Tree, VideoCamera,
} from "@phosphor-icons/react";

const ICONS = {
  wifi: WifiHigh, fire: Fire, tv: Television, kitchen: CookingPot, bath: Bathtub,
  terrace: ForkKnife, parking: Car, key: Key, garden: Tree, camera: VideoCamera,
};

export default function Amenities() {
  const { t } = useLang();
  return (
    <section id="amenities" data-testid="amenities-section" className="section-pad bg-[hsl(var(--primary))] text-white">
      <div className="container-x">
        <div className="max-w-2xl mb-16">
          <div className="overline !text-[hsl(var(--accent))] mb-5">{t.amenities.eyebrow}</div>
          <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight whitespace-pre-line">
            {t.amenities.title}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10">
          {t.amenities.list.map((a, i) => {
            const Icon = ICONS[a.icon] || WifiHigh;
            return (
              <div key={i} data-testid={`amenity-${a.icon}`} className="bg-[hsl(var(--primary))] p-7 md:p-9 flex flex-col items-start gap-5 min-h-[180px] hover:bg-[hsl(var(--primary))]/80 transition-colors">
                <Icon size={32} weight="light" className="text-[hsl(var(--accent))]" />
                <div className="text-sm md:text-base font-light leading-snug">{a.text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
